import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Pakbonregel } from '../dto/pakbonregel';
import { CrudService, Filter } from '@mango/core';
import { Pakbon } from '../dto/pakbon';

@Injectable({ providedIn: 'root' })
export class PakbonregelService extends CrudService<Pakbonregel> {

    constructor(injector: Injector) { super(Pakbonregel, injector); }


    getPakbonFilter(pakbon: Pakbon): Filter<Pakbonregel> {

        if (pakbon != null) {
            return new Filter<Pakbonregel>(fb => [fb.equal("pakbon",pakbon.id)]);
        }
        else {
            return new Filter<Pakbonregel>(fb => [fb.equal("pakbon",-1)]);
        }
    }

}
